
import HeightTween from 'vue-height-tween-transition'
import colors from '/assets/vars/colors.json'
import { padNum } from '/services/helpers'

export default

	components: { HeightTween }

	props: block: Object
	# CSS transition delay not working, so setting a delay for the button transition with JavaScript
	data: ->
		active: 0
		colors: colors
		forceUpdate: 0

	computed:
		classes: -> [
			'theme-light' if @block.theme == 'light'
			'theme-dark' if @block.theme == 'dark'
			'image-left' if @block.paneLayout == 'left'
			'image-right' if @block.paneLayout == 'right'
		]

		sizes: -> "(min-width: 768px) 720px, (max-width: 767px) 100vw"

		paneImage: ->
			pane = @block.panes.find (pane, index) => index == @active
			if pane then return pane.image else return undefined

		paneVideo: ->
			pane = @block.panes.find (pane, index) => index == @active
			if pane then return pane.video else return undefined

		viewportWidth: -> @$store.state.layout.viewport.width

	methods:
		padNum: padNum
		paneClass: (index) -> "active" if index == @active
		select: (index) -> @active = index
		updateScroller: ->
			@$scroller.update()
			@$nextTick =>
				@forceUpdate++
				return unless @viewportWidth < 768
				@$refs.pane[@active].scrollIntoView({behavior: 'smooth', block: 'start'})

